import React from 'react';
import { Organization } from '../../types/organizations';
import { getStatusBadgeClasses, getSubscriptionBadgeClasses } from '../../utils/badgeHelpers';
import { formatTimestampWithTimezone } from '../../utils/timeHelpers';

interface OrganizationInfoCardProps {
  organization: Organization;
}

const OrganizationInfoCard: React.FC<OrganizationInfoCardProps> = ({ 
  organization
}) => {
  return (
    <div className="bg-white rounded-lg shadow p-6 w-full">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Organization Information</h3>
      <div className="space-y-3">
        <div className="flex justify-between">
          <span className="text-sm font-medium text-gray-500">Legal Entity Name:</span>
          <span className="text-sm text-gray-900">{organization.legal_entity_name}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-sm font-medium text-gray-500">Website:</span>
          <span className="text-sm text-gray-900">{organization.website || 'Not specified'}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-sm font-medium text-gray-500">Types:</span>
          <span className="text-sm text-gray-900">{organization.types?.join(', ') || 'Not specified'}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-sm font-medium text-gray-500">Subscription Status:</span>
          <div className="text-sm text-gray-900">
            <span className={getSubscriptionBadgeClasses(organization.subscription_status)}>
              {organization.subscription_status}
            </span>
            {organization.subscription_cycle && (
              <span className="text-slate-500 text-xs mt-1 ml-2">
                {organization.subscription_cycle}
              </span>
            )}
          </div>
        </div>
        <div className="flex justify-between">
          <span className="text-sm font-medium text-gray-500">Status:</span>
          <span className="text-sm text-gray-900">
            <span className={getStatusBadgeClasses(organization.status)}>
              {organization.status}
            </span>
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-sm font-medium text-gray-500">Subscription Start Date:</span>
          <span className="text-sm text-gray-900">{organization.subscription_start_date || 'Not specified'}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-sm font-medium text-gray-500">Last Updated:</span>
          <span className="text-sm text-gray-900">{formatTimestampWithTimezone(organization.updated_at)}</span>
        </div>
      </div>
    </div>
  );
};

export default OrganizationInfoCard;
